import { render, staticRenderFns } from "./DeleteCompanyModal.vue?vue&type=template&id=a8b9cf14&"
import script from "./DeleteCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports